import angular from 'angular';
import metricsComponent from './metrics.component';

export default angular.module('metrics', []).component('metrics', metricsComponent);



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/metrics/metrics.js